import { render, staticRenderFns } from "./WhatsappTemplatesForm.vue?vue&type=template&id=17feda8c&scoped=true&"
import script from "./WhatsappTemplatesForm.vue?vue&type=script&lang=js&"
export * from "./WhatsappTemplatesForm.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappTemplatesForm.vue?vue&type=style&index=0&id=17feda8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17feda8c",
  null
  
)

export default component.exports